import { render, staticRenderFns } from "./FiCodemirror.vue?vue&type=template&id=b8611cb6&scoped=true&lang=pug&"
import script from "./FiCodemirror.vue?vue&type=script&lang=js&"
export * from "./FiCodemirror.vue?vue&type=script&lang=js&"
import style0 from "./FiCodemirror.vue?vue&type=style&index=0&id=b8611cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8611cb6",
  null
  
)

export default component.exports